import React from "react";
import { HelpCircleIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { planningQuestions } from "../../data/framework";
export function ProblemSection() {
  return <section className="w-full bg-surface px-5 py-16 sm:py-24" data-id="element-311" data-mp="8kjvng7i4ubs">
      <div className="mx-auto max-w-5xl" data-id="element-312" data-mp="div3xmi5ewrw">
        <SectionHeading eyebrow="A Different Way to Understand Self-Ligating Orthodontics" title="You Know How Self-Ligating Brackets Work. But Do You Understand the Clinical Decisions Behind Every Treatment Phase?" subtitle="Self-ligating orthodontics involves much more than choosing a bracket system. Before beginning treatment, you need to consider:" data-id="element-313" data-mp="dhttnk8yieb8" />

        <ul className="mx-auto mt-10 grid max-w-4xl gap-3 md:grid-cols-2" data-id="element-314" data-mp="3qsj2l0cfsf5x">
          {planningQuestions.map(q => <li key={q} className="flex items-start gap-3 rounded-xl bg-white p-4 text-[15px] font-semibold leading-snug text-ink shadow-card" data-id="element-315" data-mp="1oz1slq0u3280">
              <HelpCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-316" data-mp="1nmjm81o11mqv" />
              {q}
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-3xl rounded-3xl bg-navy-900 p-6 text-center sm:p-10" data-id="element-317" data-mp="1wfwo3t42jyp3">
          <p className="text-sm font-bold uppercase tracking-wider text-gold" data-id="element-318" data-mp="1set7v5i400nc">And perhaps the most important question:</p>
          <p className="mt-3 text-2xl font-black leading-tight text-white sm:text-3xl" data-id="element-319" data-mp="14o71dinr6ofg">
            How do you connect all these decisions into one coherent clinical strategy?
          </p>
          <p className="mt-5 text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-320" data-mp="1dq6j6d6ldwjg">
            That's where <strong className="text-white" data-id="element-321" data-mp="18q2ctfzeei6y">SELF-LIGATING ORTHODONTICS BLUEPRINT™</strong> comes in. Instead of
            presenting disconnected information, this educational reference organizes the subject into six connected
            stages.
          </p>
        </div>

        <SectionCta label="Show Me the 6 Connected Stages" data-id="element-322" data-mp="2k83bw3vqaxcw" />
      </div>
    </section>;
}